import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// html2canvas measures text baselines with a 1px gif <img>; Tailwind makes every img display:block,
// which pushes all PDF text ~10px too low. Keep that probe inline while exporting.
const BASELINE_FIX = 'img[src^="data:image/gif;base64"] { display: inline !important; }';

const imagesReady = (node) => Promise.all([...node.querySelectorAll('img')].map((img) => (
  img.complete ? Promise.resolve() : new Promise((done) => { img.onload = done; img.onerror = done; })
)));

// Saves the certificate exactly as shown on screen as a one-page PDF
export async function downloadCertificatePdf(node, fileName) {
  await document.fonts?.ready;
  await imagesReady(node);
  const fix = document.createElement('style');
  fix.textContent = BASELINE_FIX;
  document.head.appendChild(fix);
  let canvas;
  try {
    canvas = await html2canvas(node, { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false });
  } finally {
    fix.remove();
  }
  const w = canvas.width / 2;
  const h = canvas.height / 2;
  const pdf = new jsPDF({ orientation: w > h ? 'landscape' : 'portrait', unit: 'px', format: [w, h], hotfixes: ['px_scaling'], compress: true });
  pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, w, h);
  pdf.save(fileName);
}
